<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper ranking-page">
      <!-- BEGIN: Subheader -->
      <div class="m-subheader ">
        <div class="align-items-center break-word">
          <div class="mr-auto">
            <h1 class="m-subheader__title full-max-width" v-encode="pageTitle"></h1>
          </div>
        </div>
      </div>
      <!-- END: Subheader -->
      <div v-if="!enabled" class="m-content text-left" >
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <div class="tab-content">
              <div class="tab-pane active" id="m_widget2_tab1_content" aria-expanded="true">
                Brak danych
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="m-content break-word m-content-ls">
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <p v-if="description" class="mb-4" v-html="description"></p>
            <div class="text-center" :class="[!isLoading && 'overflow-x-auto']">
              <spinner v-if="isLoading"></spinner>
              <b-table-lite v-else striped
                            head-variant="grey"
                            :items="items"
                            :fields="tableFields"
                            :show-empty="true">
                <template v-slot:head()="data">
                  <div class="d-flex align-items-center justify-content-center">
                    <a v-if="showPreviousControl(data.column)" href="#" class="mr-3"
                       @click="previousColumn">
                      <i class="fa fa-angle-left"></i>
                    </a>
                    <div>{{ data.label }}</div>
                    <a v-if="showNextControl(data.column)" href="#" class="ml-3"
                       @click="nextColumn">
                      <i class="fa fa-angle-right"></i>
                    </a>
                  </div>
                </template>
              </b-table-lite>
              <div v-if="!isLoading && !items.length">
                <h5>Jeszcze nikt nie zdobył {{ pointsName }}.</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Page from "@/components/pages/Page";
import Spinner from "@/components/spinner/Spinner";
import Screen from "@/mixins/screen";
import PageTitle from "@/mixins/pageTitle";
import Encode from "@/directives/encode";

export default {
  name: "RankingPage",
  components: {Page, Spinner},
  mixins: [
      Screen,
      PageTitle('Ranking'),
  ],
  directives: {Encode},
  data() {
    return {
      isLoading: true,
      fields: [],
      items: [],
      breakPoint:  650,
      currentColumn: 2,
    };
  },
  mounted() {
    if (this.enabled) {
      this.fetchRanking();
    }else{
      this.isLoading = false;
    }
  },
  methods: {
    ...mapActions([
        'pushToFirstAvailablePage',
    ]),
    fetchRanking() {
      this.$http.get('ranking')
          .then(r => {
            this.fields = r.data.fields;
            this.items = r.data.items;
            this.isLoading = false;
          })
    },
    previousColumn() {
      if (this.currentColumn === 2) {
        return;
      }

      this.currentColumn -= 1;
    },
    nextColumn() {
      if (this.currentColumn === this.fields.length) {
        return;
      }

      this.currentColumn += 1;
    },
    showPreviousControl(column) {
      if (!this.breakTable) {
        return false; //desktop
      }

      if (!this.thirdCol.length) {
        return false; //no third column
      }

      if (this.thirdCol[0].key !== column) {
        return false;
      }

      return this.currentColumn !== 2;
    },
    showNextControl(column) {
      if (!this.breakTable) {
        return false; //desktop
      }

      if (!this.thirdCol.length) {
        return false; //no third column
      }

      if (this.thirdCol[0].key !== column) {
        return false;
      }

      return this.currentColumn !== this.fields.length - 1;
    },
  },
  computed: {
    ...mapState({
      enabled: state => state.settings.ranking.enabled,
      description: state => state.settings.ranking.description,
      pointsConfig: state => state.settings.points,
      pointsName() {
        return this.pointsConfig.name ? this.pointsConfig.name : 'punkty';
      }
    }),
    breakTable() {
      return this.windowWidth < this.breakPoint;
    },
    tableFields() {
      if (!this.breakTable) {
        return this.fields
      }
      let cols =  this.fields.slice(0, 2)

      cols.push(this.thirdCol)

      return cols;
    },
    thirdCol() {
      if (!this.breakTable) {
        return [];
      }

      return this.fields.slice(this.currentColumn, this.currentColumn + 1);
    },
  }
}
</script>

<style scoped>
.ranking-page >>> .table-ls {
  background-color: var(--accent-color);
  color: var(--btn-color);
}

.ranking-page >>> .thead-grey {
  background-color: #393939;
  color: #fff;
}

.ranking-page >>> .table thead th {
  vertical-align: middle !important;
}

.overflow-x-auto {
  overflow-x: auto;
}
</style>
